import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
function Box({
  children,
  as = "div",
  ...props
}) {
  return /* @__PURE__ */ jsx(BoxStyled, {
    as,
    ...props,
    children
  });
}
const BoxStyled = styled.div.withConfig({
  shouldForwardProp: (prop) => {
    if (prop.startsWith("margin") || prop.startsWith("padding")) {
      return false;
    }
    return true;
  }
}).withConfig({
  displayName: "BoxStyled",
  componentId: "sc-180ptwx-0"
})(["margin:", ";margin-inline:", ";margin-block:", ";margin-top:", ";margin-right:", ";margin-bottom:", ";margin-left:", ";padding:", ";padding-inline:", ";padding-block:", ";padding-top:", ";padding-right:", ";padding-bottom:", ";padding-left:", ";"], getValue("margin"), getValue("marginInline"), getValue("marginBlock"), getValue("marginTop"), getValue("marginRight"), getValue("marginBottom"), getValue("marginLeft"), getValue("padding"), getValue("paddingInline"), getValue("paddingBlock"), getValue("paddingTop"), getValue("paddingRight"), getValue("paddingBottom"), getValue("paddingLeft"));
function getValue(prop) {
  return (props) => {
    return props[prop] ? token[`spacing${props[prop]}`] : void 0;
  };
}
export {
  Box
};
//# sourceMappingURL=Box.js.map
